import Exception from './Exception';
/**
 * Custom Error class of type Exception.
 */
export default class ReaderException extends Exception {
}
ReaderException.kind = 'ReaderException';
//# sourceMappingURL=ReaderException.js.map